import { Component, OnInit } from '@angular/core';
import {AchatService} from '../../../../../../services/achat/achat.service';

@Component({
  selector: 'app-non-paye-fac-f',
  templateUrl: './non-paye-fac-f.component.html',
  styleUrls: ['./non-paye-fac-f.component.scss']
})
export class NonPayeFacFComponent implements OnInit {

    constructor(private dataService: AchatService) {}

    ngOnInit(): void {
        this.dataService.filterFactureFournisseurByStatus('Non Payé');
    }

}
